import React, { Component } from "react";
import { DIMENSIONS } from "utils/Dimensions";
import styled from "styled-components";

export default class NumberColumnEditor extends Component {
  constructor(props) {
    super(props);
    var value = this.getDefaultValue(props) + "";
    value = value.split(".")[1] === "00" ? value.split(".")[0] : value;
    this.state = {
      value: value
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(this);
    this.handleChange()
  }

  getDefaultValue(props) {
    if (props.colDef?.cellRendererParams?.columnTypeId === "5" || props.colDef?.cellRendererParams?.columnTypeId === "17" || props.colDef?.cellRendererParams?.columnTypeId === "22"){
      const columnTypeId = props.colDef?.cellRendererParams?.columnTypeId;
      if(!props.charPress && isNaN(props.value)){
        return "";
      }
      let decimals = props.columnOptions?.decimals ? props.columnOptions.decimals : 2;
      let numberDecimals = props.columnOptions?.decimals ?? 2;
      return props.charPress ? props.charPress : (columnTypeId == "22" ? (props.value*100).toFixed(decimals - 2) : Number(props.value).toFixed(numberDecimals));
    }
    return props.charPress ? props.charPress : props.value ? props.value : "";
  }

  handleChange = (value = this.state.value) => {
    var strippedValue = value.replace(/[,]/g, "");
    strippedValue = strippedValue.replace("%","");
    var numbers = /^(\d+)?.(\d+)?$/;
    if (value === "" || strippedValue.match(numbers)) {
      if (this.props.colDef.store.isLazyLoadEnabled) {
        this.props.colDef.store.isCurrentRowSaving = true;
      }
      if (this.props.colDef?.cellRendererParams?.columnTypeId === "22") {
        this.props.onChange((Number(strippedValue / 100).toFixed(this.props.columnOptions?.decimals ?? 2)).toString());
      } else if (this.props.colDef?.cellRendererParams?.columnTypeId === "5" || this.props.colDef?.cellRendererParams?.columnTypeId === "17") {
        this.props.onChange((Number(strippedValue).toFixed(this.props.columnOptions?.decimals ?? 2)).toString()); 
      } else {
        this.props.onChange(strippedValue);
      }
      this.setState({ value: value });
    }
  };

  componentDidMount() {
    this.refs.container.addEventListener("keydown", this.arrowKeyNavigation);
    this.focus();
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener("keydown", this.arrowKeyNavigation);
  }

  focusNextCell = (rowIndex, colId, isArrowDown = false) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    if (isArrowDown) {
      this.props.colDef.store.addRowOnGrid(
        rowIndex,
        this.props.node.id,
        this.props.context,
        colId
      );
    }
    this.props.api.setFocusedCell(rowIndex, colId);
  };

  arrowKeyNavigation = (event) => {
    if ([13].indexOf(event.keyCode) > -1) {
      this.handleChange();
      this.focusNextCell(this.props.rowIndex + 1, this.props.column.colId, true);
    }
    if (event.key === "ArrowUp") {
      this.focusNextCell(
        this.props.rowIndex === 0 ? 0 : this.props.rowIndex - 1,
        this.props.column.colId
      );
    }
    if (event.key === "ArrowDown") {
      this.focusNextCell(this.props.rowIndex + 1, this.props.column.colId, true);
    }
  };

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return false;
  }

  focus() {
    window.setTimeout(() => {
      if (this.refs.input) {
        this.refs.input.focus();
        this.refs.input.value = "";
        this.refs.input.value = this.state.value;
      }
    }, 10);
  }

  render() {
    return (
      <div
        ref="container"
        style={{
          width: Number(this.props.colDef.width) - 15,
          height: this.props.node.rowHeight - 5,
          maxHeight: 10,
        }}
      >
        <StyledNumberInput
          ref="input"
          width={Number(this.props.colDef.width) - 15}
          rowHeight={this.props.node.rowHeight}
          onChange={(e) => this.handleChange(e.target.value)}
          value={this.state.value}
        />
      </div>
    );
  }
}

const StyledNumberInput = styled.input`
  width: ${({ width }) => width + "px"};
  position: absolute;
  top: 0px;
  left: 0px;
  padding-left: 10px;
  border: none;
  outline: none;
  border-radius: 4px;
  padding-top: ${({ rowHeight }) =>
    rowHeight <= DIMENSIONS.cell_height_short &&
    rowHeight > DIMENSIONS.cell_height_compact
      ? "0px"
      : "8px"};
  line-height: ${({ rowHeight }) =>
    rowHeight <= DIMENSIONS.cell_height_compact ? "normal" : ""};
`;